export default __webpack_public_path__ + "static/media/gp.a4a9471d.png";